import { Outlet } from "react-router"

const UsersLayout = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default UsersLayout
